import { OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import { filterModalType } from './filterModalType';
import FacetType from './facetType';
import SearchType from './SearchType';
// eslint-disable-next-line import/prefer-default-export
export const facetTypeDetails = {
  [FacetType.ALERT_NAME]: {
    id: 1,
    validOperators: [OperatorTypes.CONTAINS, OperatorTypes.NOT_CONTAIN],
    displayValue: 'Alert Name',
    modalType: filterModalType.B,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.ALERT_TRIGGERED]: {
    id: 2,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Triggered Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.ALERT_TAGS]: {
    id: 3,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.EQUAL_TO_BOOLEAN,
      OperatorTypes.NOT_EQUAL_TO,
    ],
    displayValue: 'Alert Tags',
    modalType: filterModalType.A,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.CHANNEL_TYPE]: {
    id: 4,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Channel Type',
    modalType: filterModalType.C,
    validSearchTypes: [SearchType.ALERT, SearchType.CHANNEL],
  },
  [FacetType.PUSH_STATUS]: {
    id: 5,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Push Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.ALERT, SearchType.DEVICE],
  },
  [FacetType.DEVICE_TAGS]: {
    id: 6,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.EQUAL_TO_BOOLEAN,
      OperatorTypes.NOT_EQUAL_TO,
    ],
    displayValue: 'Device Tags',
    modalType: filterModalType.A,
    validSearchTypes: [SearchType.DEVICE, SearchType.CHANNEL],
  },
  [FacetType.ALERT_FAVORITE]: {
    id: 7,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Favorited Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.HISTORICAL_ALERT_EVENT]: {
    id: 8,
    validOperators: [OperatorTypes.BETWEEN, OperatorTypes.NOT_BETWEEN],
    displayValue: 'Historic Alert Event',
    modalType: filterModalType.E,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.NOTIFICATION_GROUP]: {
    id: 9,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.EQUAL_TO_BOOLEAN,
      OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Notification Group',
    modalType: filterModalType.A,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.ALERT_SUSPENDED]: {
    id: 10,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Suspended Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.ALERT],
  },
  // [facetType.THRESHOLD]: {
  //   id: 11,
  //   validOperators: [
  //     OperatorTypes.GREATER_THAN, OperatorTypes.LESS_THAN, OperatorTypes.EQUAL_TO_VALUE,
  //   ],
  //   displayValue: 'Threshold',
  //   modalType: filterModalType.C,
  // },
  [FacetType.ALERT_ACKNOWLEDGED]: {
    id: 12,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Acknowledged Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.DEVICE_SUSPENDED]: {
    id: 13,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Suspended Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.DEVICE],
  },
  [FacetType.DEVICE_NAME]: {
    id: 14,
    validOperators: [OperatorTypes.CONTAINS, OperatorTypes.NOT_CONTAIN],
    displayValue: 'Device Name',
    modalType: filterModalType.B,
    validSearchTypes: [SearchType.DEVICE, SearchType.CHANNEL],
  },
  [FacetType.DEVICE_TYPE]: {
    id: 15,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Device Type',
    modalType: filterModalType.C,
    validSearchTypes: [SearchType.DEVICE],
  },
  [FacetType.DEVICE_FIRMWARE_STATUS]: {
    id: 16,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Device Firmware Status',
    modalType: filterModalType.D,
    validSearchTypes: [SearchType.DEVICE],
  },
  [FacetType.DEVICE_LINK_CONNECTION]: {
    id: 17,
    validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
    displayValue: 'Device Link Connection',
    modalType: filterModalType.F,
    validSearchTypes: [SearchType.DEVICE],
  },
  [FacetType.ALERT_QUIET_TIME]: {
    id: 18,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.EQUAL_TO_BOOLEAN,
      OperatorTypes.NOT_EQUAL_TO,
    ],
    displayValue: 'Alert Quiet Times',
    modalType: filterModalType.A,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.ALERT_NOTIFICATION_TEMPLATES]: {
    id: 19,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.NOT_EQUAL_TO,
      OperatorTypes.EQUAL_TO_BOOLEAN],
    displayValue: 'Alert Notification Templates',
    modalType: filterModalType.A,
    validSearchTypes: [SearchType.ALERT],
  },
  [FacetType.CHANNEL_GROUP_NAME]: {
    id: 20,
    validOperators: [OperatorTypes.CONTAINS, OperatorTypes.NOT_CONTAIN],
    displayValue: 'Sensor Name',
    modalType: filterModalType.B,
    validSearchTypes: [SearchType.CHANNEL],
  },
  [FacetType.CHANNEL_LAST_READING_TIMESTAMP]: {
    id: 21,
    validOperators: [OperatorTypes.BETWEEN, OperatorTypes.NOT_BETWEEN],
    displayValue: 'Last Reading Timestamp',
    modalType: filterModalType.E,
    validSearchTypes: [SearchType.CHANNEL],
  },
  // [FacetType.CHANNEL_LAST_READING_VALUE_COMPARISON]: {
  //   id: 22,
  //   validOperators: [
  //     OperatorTypes.GREATER_THAN,
  //     OperatorTypes.LESS_THAN,
  //     OperatorTypes.EQUAL_TO_VALUE],
  //   displayValue: 'Last Reading Value Comparison',
  //   modalType: filterModalType.G,
  //   validSearchTypes: [SearchType.CHANNEL],
  // },
  [FacetType.CHANNEL_ALERT_COUNT]: {
    id: 23,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.GREATER_THAN,
      OperatorTypes.LESS_THAN],
    displayValue: 'Alert Count',
    modalType: filterModalType.G,
    validSearchTypes: [SearchType.CHANNEL],
  },
  [FacetType.CHANNEL_ALERT_COUNT]: {
    id: 23,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
      OperatorTypes.GREATER_THAN,
      OperatorTypes.LESS_THAN],
    displayValue: 'Alert Count',
    modalType: filterModalType.G,
    validSearchTypes: [SearchType.CHANNEL],
  },
  [FacetType.DEVICE_ID]: {
    id: 24,
    validOperators: [
      OperatorTypes.EQUAL_TO_VALUE,
    ],
    displayValue: 'Device ID',
    // current only used in dropdown so no way to get this modal
    modalType: filterModalType.C,
    validSearchTypes: [SearchType.CHANNEL],
  },
  // [FacetType.SENSOR_PORT]: {
  //   id: 24,
  //   validOperators: [OperatorTypes.EQUAL_TO_VALUE, OperatorTypes.NOT_EQUAL_TO],
  //   displayValue: 'Sensor Port',
  //   modalType: filterModalType.C,
  //   validSearchTypes: [SearchType.CHANNEL],
  // },
};
